import { ScheduleAiJobRequest } from './schedule-ai-job-request';

export class ScheduleAiJobsRequest {
  public AiJobs: ScheduleAiJobRequest[] = [];
}
